import {Component, Inject, OnInit} from '@angular/core';
import {CommissionRedirection} from '../../../../shared/interface/commission-redirection';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {FormBuilder, FormControl, FormGroup} from '@angular/forms';
import {delay, first, tap} from 'rxjs/operators';
import {Uuid} from '../../../../shared/interface/response/uuid';
import {HttpErrorResponse} from '@angular/common/http';
import {MatSnackBar} from '@angular/material/snack-bar';
import {CommissionRedirectionService} from '../../../../shared/services/commission-redirection.service';
import {User} from "../../../../shared/interface/user";
import {of} from "rxjs";

export interface ChangeRatePaidDialogData {
  commissionRedirection: CommissionRedirection;
}

@Component({
  selector: 'app-change-rate-paid-dialog',
  templateUrl: './change-rate-paid-dialog.component.html',
  styleUrls: ['./change-rate-paid-dialog.component.scss']
})
export class ChangeRatePaidDialogComponent implements OnInit {

  commissionRedirection: CommissionRedirection;
  ratePaidForm: FormGroup;
  ratePaidControl: FormControl;
  riskControl: FormControl;
  processingRequest = false;

  constructor(
    public dialogRef: MatDialogRef<ChangeRatePaidDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ChangeRatePaidDialogData,
    private fb: FormBuilder,
    private snack: MatSnackBar,
    private commissionRedirectionService: CommissionRedirectionService,
  ) {
    this.commissionRedirection = data.commissionRedirection;
    this.ratePaidForm = fb.group({
      ratePaid: this.ratePaidControl = fb.control(this.commissionRedirection.ratePaid, []),
      risk: this.riskControl = fb.control(this.commissionRedirection.risk, [])
    });
  }

  ngOnInit(): void {
    this.initialize(this.commissionRedirection);
  }

  sendForm(): void {
    this.processingRequest = true;

    this.commissionRedirectionService.updateRatePaid(this.ratePaidForm.value, this.commissionRedirection.uuid)
      .pipe(
        first()
      )
      .subscribe(() => {
        this.snack.open('Pomyślnie zaktualizowano obiekt', '', {
          duration: 2000,
        });
        this.processingRequest = false;
        this.dialogRef.close(true);
      }, (error: HttpErrorResponse) => {
        this.processingRequest = false;

        this.snack.open('Podczas aktualizacji obiektu wystąpił błąd', error.status.toString(), {
          duration: 2000,
        });
      })
    ;
  }

  cancel(): void {
    this.dialogRef.close(false);
  }
  initialize(commissionRedirection: CommissionRedirection): void {
    of(commissionRedirection)
      .pipe(
        delay(0),
        tap(() => {
          this.ratePaidForm.setValue({
            ratePaid: commissionRedirection.ratePaid ?? '',
            risk: commissionRedirection.risk?.id ?? ''
          });
        })
      ).subscribe();
  }
}
